
<div class="position-relative">
  <span class="fa fa-search search-icon"> </span>
  <input type="search" class="form-control pl-5"
         [(ngModel)]="searchField"
         (ngModelChange)="onSearchChange($event)"
         placeholder="{{placeholder || 'Buscar...' }}" />
</div>
